import styled, { css } from 'styled-components';
import Image from '@klv/atoms/image';
import Button from '@klv/atoms/button';
import Typography from '@klv/atoms/typography';

export const StyledButton = styled(Button)`
  margin-top: 2.4rem;
  z-index: 1;
`;

export const StyledTypography = styled(Typography)`
  margin: 2rem 0rem 1rem 0rem;
`;

export const GalleryCardLink = styled(Button)`
  text-decoration: none;
  z-index: 3;

  &::after {
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const HoverContainer = styled.div`
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition-delay: .3s;
  visibility: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  border-radius: 1.2rem;

  &::after {
    background: rgba(0,0,0,0.75); 
    bottom: 0;
    content: '';
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  } 
`;

export const HoverSVGDesktop = styled.svg`
  display: none;

  ${({ theme }) => theme.screenSize.s576.mediaQuery} {
    display: block;
  }
`;

export const HoverSVGMobile = styled.svg`
  ${({ theme }) => theme.screenSize.s576.mediaQuery} {
    display: none;
  }
`;

export const ImageContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    border-radius: 1.2rem;
    position: relative;

    svg {
      width: 100%;
      height: 100%;
      position: relative;
      stroke: ${theme.galleryCard.hoverBorderColor};
      fill: none;
      stroke-dasharray: 1660px;
      stroke-dashoffset: -1660px;
      transition: stroke-dashoffset 600ms ease-in-out;
      transform: scaleY(-1);
      
      rect {
        width: calc(100% - 4px);
        height: calc(100% - 4px);
      }
    }
  `}
`;

export const StyledImage = styled(Image)`
  width: 100%;
  object-fit: cover;
  border-radius: 1.2rem;
  transform: translateZ(0);
  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const StyledGalleryCard = styled.div`
  width: 100%;
  position: relative;
  transition: all 300ms;

  ${HoverContainer} {
    transition: opacity 300ms, visibility 300ms;
  }

  ${StyledButton} {
    transform: translateY(40rem);
    transition: all 300ms ease-in-out;
  }

  ${ImageContainer} {
    transition: all 400ms ease-in-out;
  }
  ${StyledTypography} {
    transition: all 300ms ease-in-out;
  }
  &:hover,
  &:focus,
  &:focus-within {
    outline: none;

    ${ImageContainer} {
      transform: scale(1.05);
      svg {
        stroke-dashoffset: 0px;
      }
    }

    ${StyledTypography} {
      transform: translateY(.5rem);
    }

    ${StyledButton} {
      transform: translateY(0);
      transition-delay: .2s;
      transition: all .3s ease-in-out;
    }

    ${HoverContainer} {
      opacity: 1;
      visibility: visible;
    }
  } 
`;

export const SvgWrapper = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
`;
